import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Button as AntdButton } from 'antd';
import { Link } from 'react-router-dom';
import clsx from 'clsx';

export type ButtonProps = React.ComponentProps<typeof AntdButton> & { to?: string };

/** Same as Ant's Button, but with the `ant-btn-default` class when `type` is not provided. */
export const Button = ({ to, ...rest }: ButtonProps) => {
  const AntdButtonAny: any = AntdButton;

  const Btn = (
    <AntdButtonAny
      {...rest}
      className={clsx(rest.className, !rest.type ? 'ant-btn-default' : undefined)}
    />
  );

  if (to) {
    return <Link to={to}>{Btn}</Link>;
  }

  return Btn;
};
